import React, { useCallback, useMemo } from 'react';
import Row from 'components/FeaturedSpreadsheet/components/Row';
import ScalarDatasheet from 'components/ScalarDatasheet';
import { SingleColumnProps } from './SingleColumn.props';

const SingleColumn = ({ className = '', data = [], isLegend = false, ...rest }: SingleColumnProps) => {
  // Disable sheet selection if all cells are read-only
  const disableSheetSelection = useMemo(() => data.flat().every(cell => cell.readOnly), [data]);

  const rowVariableLegend = useCallback(props => <Row {...props} isLegend={isLegend} />, [isLegend]);

  const singleColumnProps = useMemo(
    () => ({
      className,
      data,
      rowRenderer: rowVariableLegend,
      selected: disableSheetSelection ? null : undefined,
    }),
    [className, data, disableSheetSelection, rowVariableLegend]
  );

  return <ScalarDatasheet {...singleColumnProps} {...rest} />;
};

export default SingleColumn;
